/* preorder.js — pre-order launch / close countdowns.
   Drives both the PDP buy button gating and the grid hover timers from two
   epoch-second timestamps per element: data-launch and data-close.
     - before launch  → "pending": button locked, timer counts down to launch
     - launch..close   → "open":    button active, timer counts down to close
     - after close     → "closed":  button locked again
   Either timestamp is optional (0 = unset). */
(function () {
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* Largest unit only — e.g. "4 days", "18 hours", "10 minutes", "45 seconds". */
  function fmt(secs) {
    if (secs < 0) secs = 0;
    var d = Math.floor(secs / 86400);
    var h = Math.floor((secs % 86400) / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = Math.floor(secs % 60);
    if (d > 0) return d + (d === 1 ? ' day' : ' days');
    if (h > 0) return h + (h === 1 ? ' hour' : ' hours');
    if (m > 0) return m + (m === 1 ? ' minute' : ' minutes');
    return s + (s === 1 ? ' second' : ' seconds');
  }

  function phaseOf(launch, close, now) {
    if (launch && now < launch) return 'pending';
    if (close && now >= close) return 'closed';
    return 'open';
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);

    document.querySelectorAll('[data-preorder-timer]').forEach(function (el) {
      var launch = parseInt(el.getAttribute('data-launch') || '0', 10);
      var close = parseInt(el.getAttribute('data-close') || '0', 10);
      var ph = phaseOf(launch, close, now);
      el.setAttribute('data-phase', ph);
      if (ph === 'pending') {
        el.textContent = 'Pre-orders open in ' + fmt(launch - now);
      } else if (ph === 'open' && close) {
        el.textContent = 'Closes in ' + fmt(close - now);
      } else if (ph === 'closed') {
        el.textContent = 'In production...';
      } else {
        el.textContent = 'Available now';
      }
    });

    document.querySelectorAll('[data-preorder-button]').forEach(function (btn) {
      var launch = parseInt(btn.getAttribute('data-launch') || '0', 10);
      var close = parseInt(btn.getAttribute('data-close') || '0', 10);
      var ph = phaseOf(launch, close, now);
      var label = btn.querySelector('[data-preorder-label]');
      if (ph === 'open') {
        btn.classList.remove('is-locked');
        btn.removeAttribute('aria-disabled'); // aria, not native disabled — stays hoverable
        if (label) label.textContent = btn.getAttribute('data-open-label') || 'Add to Cart';
      } else {
        btn.classList.add('is-locked');
        btn.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = ph === 'pending' ? 'Available soon' : 'Pre-order closed';
      }
    });
  }

  function start() {
    if (!document.querySelector('[data-preorder-timer], [data-preorder-button]')) return;
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
